/* eslint-disable max-len */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import ReactMarkdown from 'react-markdown';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    height: 450,
    zIndex: 101,
    marginRight: 15,
    marginLeft: 15,
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  subHeader: {
    color: 'black',
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: 30,
  },
  header: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  mainTitle: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: '60px',
    [theme.breakpoints.between('0', '600')]: {
      fontSize: '25px',
    },
  },
  mainSubTitle: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: '30px',
  },
  mainSmallSubTitle: {
    color: 'black',
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: 16,
  },
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  bodyText: {
    fontFamily: 'Flama-Book',
    fontSize: '18px',
    lineHeight: 1.7,
    textAlign: 'left',
    marginRight: 40,
  },
  serviceImage: {
    textAlign: 'left',
  },
  mainContainer: {
    marginTop: 120,
    [theme.breakpoints.between('0', '600')]: {
      marginTop: 100,
    },
  },
  imageTag: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

const Overview = (props) => {
  const classes = useStyles();
  const { data } = props;

  const componentBox = [
    <Grid container alignItems="flex-start">
      <Grid item xs={12} md={6} order={{ xs: 3, md: 3 }}>
        <Box position="relative" zIndex="100">
          <Typography variant="h5" className={classes.subHeader}>{data.coverageSubTitle}</Typography>
          <Typography variant="h3" className={classes.header}>{data.coverageTitle}</Typography>
          <ReactMarkdown className={classes.bodyText}>{data.coverageDescription}</ReactMarkdown>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 4, md: 4 }}>
        <Box position="relative">
          <Box className={classes.image}>
            <img src={data ? data.coveragePicture.url : '/'} className={classes.imageTag} alt="Coverage" />
          </Box>
        </Box>
      </Grid>
    </Grid>,
    <Grid container alignItems="flex-start">
      <Grid item xs={12} md={6} order={{ xs: 3, md: 3 }}>
        <Box position="relative" zIndex="100">
          <Typography variant="h5" className={classes.subHeader}>{data.worldserviceSubTitle}</Typography>
          <Typography variant="h3" className={classes.header}>{data.worldserviceTitle}</Typography>
          <ReactMarkdown className={classes.bodyText}>{data.worldserviceDescription}</ReactMarkdown>
          <Box className={classes.serviceImage}>
            <img src={data ? data.servicePicture2.url : '/'} height="100px" width="100px" objectFit="cover" alt="People" />
            <img src={data ? data.servicePicture3.url : '/'} height="100px" width="300px" objectFit="cover" alt="People" />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 4, md: 4 }}>
        <Box position="relative">
          <Box className={classes.image}>
            <img src={data ? data.servicePicture.url : '/'} className={classes.imageTag} alt="World Service" />
          </Box>
        </Box>
      </Grid>
    </Grid>,
    <Grid container alignItems="flex-start">
      <Grid item xs={12} md={6} order={{ xs: 3, md: 3 }}>
        <Box position="relative" zIndex="100">
          <Typography variant="h5" className={classes.subHeader}>{data.peopleSubTitle}</Typography>
          <Typography variant="h3" className={classes.header}>{data.peopleTitle}</Typography>
          <ReactMarkdown className={classes.bodyText}>{data.peopleDescription}</ReactMarkdown>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 4, md: 4 }}>
        <Box position="relative">
          <Box className={classes.image}>
            <img src={data ? data.peoplePicture.url : '/'} className={classes.imageTag} alt="People" />
          </Box>
        </Box>
      </Grid>
    </Grid>,
    <Grid container alignItems="flex-start">
      <Grid item xs={12} md={6} order={{ xs: 3, md: 3 }}>
        <Box position="relative" zIndex="100">
          <Typography variant="h5" className={classes.subHeader}>{data.stabilitySubTitle}</Typography>
          <Typography variant="h3" className={classes.header}>{data.stabilityTitle}</Typography>
          <ReactMarkdown className={classes.bodyText}>{data.stabilityDescription}</ReactMarkdown>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 4, md: 4 }}>
        <Box className={classes.image}>
          <img src={data ? data.stabilityPicture.url : '/'} className={classes.imageTag} alt="Stability" />
        </Box>
      </Grid>
    </Grid>,
  ];

  return (
    <Box className={classes.mainContainer}>
      <Box position="relative" zIndex="100">
        <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
          <Typography variant="h3" className={classes.mainSubTitle}>NORWAY&apos;S</Typography>
          <Typography variant="h5" className={classes.mainTitle}>{data.groundHandlingTitle}</Typography>
          <ReactMarkdown className={classes.bodyText}>{data.groundHandlingDescription}</ReactMarkdown>
          <Typography variant="h6" className={classes.mainSmallSubTitle}>{data.groundHandlingUnderTitle}</Typography>
        </AnimatedOnScroll>
      </Box>
      <Carousel
        showArrows
        showThumbs={false}
        infiniteLoop
        emulateTouch
        interval={5000}
        transitionTime={1000}
        autoPlay
        showStatus={false}
      >
        {componentBox.map((item) => (
          <Grid pt={{ xs: 4, md: 14 }} position="relative">
            <Box className={classes.mainBox}>
              {item}
            </Box>
          </Grid>
        ))}
      </Carousel>
    </Box>
  );
};

export default Overview;
